import Flex from '@talkdesk/cobalt-react-flex'
import Box from '@talkdesk/cobalt-react-box'
import Image from '@talkdesk/cobalt-react-image'
import Button from '@talkdesk/cobalt-react-button'
import { ROOT } from '../../constants/links'
import { TALKDESK_LOGO } from '../../constants/images'
import { useTranslation } from 'react-i18next'
import redirect from '../../utils/redirect'
import styles from './TalkdeskNavbar.module.css'

const TalkdeskNavbar = ({
  brandingSettings: { branding },
  showReturnButton = true,
}) => {
  const { t } = useTranslation()

  return (
    <Box width='100%' className={styles.navbar}>
      <Flex alignY='center' paddingX={4} paddingY={2}>
        {branding.assets && (
          <Flex className={styles.navbarLeft}>
            <a href={ROOT}>
              <Image
                src={TALKDESK_LOGO(branding.assets)}
                alt={t('common.logoAlt', { name: branding.name })}
                width={100}
                height={20}
              />
            </a>
          </Flex>
        )}
        {showReturnButton && (
          <Flex className={styles.navbarRight}>
            <Button onClick={() => redirect()} type='secondary' size='small'>
              {t('mfa.headerAction')}
            </Button>
          </Flex>
        )}
      </Flex>
    </Box>
  )
}

export default TalkdeskNavbar
